import _ from './lodash.js';

export const stripHtml = (html) => {
    let tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
};

export const pickNonEmptyValues = (obj, keys = []) => {
    // Guard against null/undefined object
    if (!obj || typeof obj !== 'object') {
        return {};
    }
    
    // Simple implementation without lodash dependency
    const result = {};
    
    for (const key of keys) {
        if (!(key in obj)) continue;
        
        const value = obj[key];
        
        // Check if value is "non-empty"
        if (value === null || value === undefined) continue;
        if (typeof value === 'string' && value.trim() === '') continue;
        if (Array.isArray(value) && value.length === 0) continue;
        if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) continue;
        
        // Value is non-empty, include it
        result[key] = value;
    }
    
    return result;
};

export const isNegativeNumber = (str) => {
    return /^-\d+$/.test(str);
};

export const notification = typeof window.notification === 'function' ? window.notification : alert;
